// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__24xoA","noInteraction":"EventWrapper_noInteraction__1eAui","pointerPassthrough":"EventWrapper_pointerPassthrough__1Cuw2"};